import { render, staticRenderFns } from "./KOLDetail.vue?vue&type=template&id=5760a73c&scoped=true"
import script from "./KOLDetail.vue?vue&type=script&lang=js"
export * from "./KOLDetail.vue?vue&type=script&lang=js"
import style0 from "./KOLDetail.vue?vue&type=style&index=0&id=5760a73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760a73c",
  null
  
)

export default component.exports